import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './Beginning.css'

const BLUM_URL = 'https://t.me/blum/app?startapp=memepadjetton_LIGHTER_lfviO-ref_UsG1k7XbXa'
const STONFI_URL = 'https://app.ston.fi/swap?chartVisible=true&chartInterval=1w&ft=USD₮&tt=EQDheHEbyYsL5brD3uRxNgpxtH5KoUqdP6LC98iMhBNHyh0V&fa=%225%22&referral_address=UQB1ApXMxxg4Ddzx3XXxa4keJ-IgBDJq9sLWHdfcoVHCtfK5'
const OKX_URL = 'https://web3.okx.com/token/ton/EQDheHEbyYsL5brD3uRxNgpxtH5KoUqdP6LC98iMhBNHyh0V?shortCode=iBbiOsX&from_module=market_token&shareFrom=token_info&ref=LIGHTER999COIN'

const CONTRACT = 'EQDheHEbyYsL5brD3uRxNgpxtH5KoUqdP6LC98iMhBNHyh0V'

export const Beginning = () => {
    const { t } = useTranslation()
    const story = t('story', { returnObjects: true })
    const [buyDropdownOpen, setBuyDropdownOpen] = useState(false)
    const [holderCount, setHolderCount] = useState(null)
    const dropdownRef = useRef(null)
    const [marketCap, setMarketCap] = useState(null)

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setBuyDropdownOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    useEffect(() => {
        fetch(`https://tonapi.io/v2/jettons/${CONTRACT}`)
            .then(res => res.json())
            .then(data => {
                if (data.holders_count) setHolderCount(data.holders_count)
            })
            .catch(() => {})

        fetch(`https://api.dexscreener.com/latest/dex/tokens/${CONTRACT}`)
            .then(response => response.json())
            .then(data => {
                const pair = data.pairs?.[0]
                if (pair?.marketCap) {
                    const marketCapValue = pair.marketCap

                    if (marketCapValue >= 1_000_000) {
                        setMarketCap(`$${(marketCapValue / 1_000_000).toFixed(1)}M`)
                    } else if (marketCapValue >= 1000) {
                        setMarketCap(`$${(marketCapValue / 1000).toFixed(1)}K`)
                    } else {
                        setMarketCap(`$${marketCapValue.toFixed(0)}`)
                    }
                }
            })
            .catch(() => {})
    }, [])

    const scrollToSection = (selector) => {
        const section = document.querySelector(selector)
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    return (
        <div className='hero-container'>
            <span className='hero-badge fire-title'>{story.storyOfFireBadge}</span>
            <h1 className='hero-title'>{story.heroHeadline}</h1>
            <p className='hero-tagline'>{story.heroTaglineNew}</p>
            <div className='hero-cta'>
                <div
                    className='buy-btn-wrapper'
                    ref={dropdownRef}>
                    <button
                        className='primary-cta'
                        onClick={() => setBuyDropdownOpen(!buyDropdownOpen)}>
                        {story.ctaBuy}
                    </button>
                    {buyDropdownOpen && (
                        <div className='buy-dropdown'>
                            <a
                                href={BLUM_URL}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='buy-dropdown-item'>
                                Blum Memepad
                            </a>
                            <a
                                href={STONFI_URL}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='buy-dropdown-item'>
                                {story.ctaBuyStonFi}
                            </a>
                            <a
                                href={OKX_URL}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='buy-dropdown-item'>
                                {story.ctaBuyOkx}
                            </a>
                        </div>
                    )}
                </div>
                <button
                    className='community-link'
                    onClick={() => window.open('https://t.me/lighter_coin')}>
                    {story.ctaCommunity}
                </button>
            </div>
            <div className='hero-nav-links'>
                <button
                    className='hero-nav-btn'
                    onClick={() => scrollToSection('.intro-section')}>
                    {story.ctaReadStory}
                </button>
                <button
                    className='hero-nav-btn'
                    onClick={() => scrollToSection('.tokenomics-wrapper')}>
                    {story.ctaTokenomics}
                </button>
                <button
                    className='hero-nav-btn'
                    onClick={() => scrollToSection('.roadmap-wrapper')}>
                    {story.ctaRoadmap}
                </button>
            </div>
            <div className='hero-stats-bar'>
                {holderCount !== null && (
                    <div className='hero-stat'>
                        <span className='hero-stat-value'>{holderCount}</span>
                        <span className='hero-stat-label'>{story.heroStatHolders}</span>
                    </div>
                )}
                <div className='hero-stat'>
                    <span className='hero-stat-value'>TON</span>
                    <span className='hero-stat-label'>{story.heroStatChain}</span>
                </div>
                <div className='hero-stat'>
                    <span className='hero-stat-value'>1B</span>
                    <span className='hero-stat-label'>{story.heroStatSupply}</span>
                </div>
                {marketCap && (
                    <div className='hero-stat'>
                        <span className='hero-stat-value'>{marketCap}</span>
                        <span className='hero-stat-label'>{story.heroStatMarketCap}</span>
                    </div>
                )}
            </div>
            <div
                className='scroll-hint'
                onClick={() => scrollToSection('.intro-section')}>
                <span className='scroll-hint-arrow'>↓</span>
                <span className='scroll-hint-text'>{story.scrollHint}</span>
            </div>
        </div>
    )
}
